const get = (key)=>{
    if (typeof window === 'undefined') {
        return '';
    }
    return document.cookie.split('; ').reduce((total, currentCookie)=>{
        const [storedKey, storedValue] = currentCookie.split('=');
        return key === storedKey ? decodeURIComponent(storedValue) : total;
    }, '');
};
const set = (name, value, days)=>{
    let expires = '';
    if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = '; expires=' + date.toUTCString();
    }
    document.cookie = name + '=' + (value || '') + expires + '; path=/';
};

export { get, set };
